import { css, cx } from "@emotion/css";

import { Icon } from "../../../../foundations/icons/Icon/Icon";
import { _Text } from "../../../_assets/_Text";

const TYPES = {
  valid: {
    icon: "check_circle",
    iconColor: "icon-success",
    textColor: "text-success",
  },
  invalid: {
    icon: "error",
    iconColor: "icon-danger",
    textColor: "text-danger",
  },
} as const;

interface Props {
  id?: string;
  type?: "valid" | "invalid";
  className?: string;
  children?: React.ReactNode;
  testID?: string;
}

export function FormFeedbackRAC(props: Props) {
  const {
    id,
    type = "invalid",
    className,
    children,
    testID = "form-feedback",
  } = props;

  if (!children) {
    return null;
  }

  const { icon, iconColor, textColor } = TYPES[type];

  return (
    <div className={cx(styles.feedback, className)} data-testid={testID}>
      <Icon
        type="mini"
        name={icon}
        color={iconColor}
        size="space-4"
        padding="space-05"
      />
      <_Text
        id={id}
        color={textColor}
        style="input/inline-error"
        aria-live="polite"
        truncate
      >
        {children}
      </_Text>
    </div>
  );
}

const styles = {
  feedback: css({
    display: "flex",
    gap: "var(--space-1)",
    alignItems: "top",
  }),
};
